import { useAxiosLoader } from "utils/http"
import { Spinner } from "@fourkites/elemental-loading-indicator"

export const LoadingSpinner = () => {
  const [loading] = useAxiosLoader()
  if (loading) {
    document.body.classList.add("loader-add")
  } else {
    document.body.classList.remove("loader-add")
  }

  return (
    <>
      {loading && (
        <>
          <Spinner size="medium" isLoading />
        </>
      )}
    </>
  )
}
